var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.size=='mini'?'axj-button':'axj-max-button',style:(_vm.hollow?'border-color:'+_vm.color+';background-color:#ffffff;color:'+_vm.color:'background-color:'+_vm.color+';color:#ffffff'+';border-color:'+_vm.color),on:{"click":_vm.handleClick}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f898aab","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/axj-button/index.vue
// module id = null
// module chunks = 